import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import logo from "../YB1type_Blk.png";
import "./login.css";

export default function LogoutCallbackPage(): JSX.Element {
  const { t } = useTranslation();

  function handlePopstate() {
    history.go(1);
  }

  useEffect(() => {
    history.pushState(null, "", location.href);
    window.addEventListener("popstate", handlePopstate);
    return () => {
      window.removeEventListener("popstate", handlePopstate);
    };
  }, []);

  return (
    <div className="logout-screen">
      <div className="area">
        <img src={logo} className="logo" alt="logo" />
        <div className="message">{t("logout_message1")}</div>
        <div className="message">{t("logout_message2")}</div>
      </div>
    </div>
  );
}
